import React from 'react'
import styled from 'styled-components/macro'
import useTranslation from 'next-translate/useTranslation'
import { ProductTag } from '@/components/Product/ProductTag'

interface ProductTagsProps {
  sale: boolean
  recent: boolean
}

export const TagWrapper = styled.div`
  position: absolute;
  top: -0.75rem;
  left: -0.5rem;
`

const ProductTags: React.VFC<ProductTagsProps> = ({ sale, recent }) => {
  const { t } = useTranslation('common')

  if (sale) {
    return (
      <TagWrapper>
        <ProductTag>{t('sale')}</ProductTag>
      </TagWrapper>
    )
  }
  if (recent) {
    return (
      <TagWrapper>
        <ProductTag>{t('new')}</ProductTag>
      </TagWrapper>
    )
  }
  return null
}

export default ProductTags
